import { makeStyles,withStyles } from '@material-ui/core/styles';

const SarasMakeStyles = makeStyles
const SarasWithStyles = withStyles

export default SarasMakeStyles
export {SarasMakeStyles,SarasWithStyles}